{
  "columnResizer": "Oszlopátméretező",
  "loading": "Betöltés folyamatban…",
  "loadingMore": "Továbbiak betöltése folyamatban…",
  "resizeColumn": "Oszlop átméretezése",
  "sortAscending": "Növekvő rendezés",
  "sortDescending": "Csökkenő rendezés"
}
